import { Box, Typography, Link } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { generateGtmEvent } from "../../Helpers";

const padY = 32;
const triangleLength = 12;
const tooltipWidth = 198;
const tooltipHeight = 127;

const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.text.primary,
    color: "white",
    borderRadius: 15,
    padding: "1.1em",
    width: tooltipWidth,
    height: tooltipHeight,
    boxSizing: "border-box",
    boxShadow: `inset 0px 0px 0px 2px ${theme.palette.divider}`,
  },
  outlinedButton: {
    backgroundColor: "transparent",
    borderColor: "white",
    color: "white",
    fontSize: 16,
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.2)",
      borderColor: "white",
    },
  },
  link: {
    color: "white",
    textDecorationColor: "white",
    "&:hover": {
      color: "white",
      textDecoration: "none",
    },
    "&:focus": {
      outline: "2px solid white",
    },
  },
  triangle: {},
  triangleright: {
    content: '""',
    display: "block",
    position: "absolute",
    top: 0,
    left: 0,
    width: triangleLength,
    height: triangleLength,
    backgroundColor: theme.palette.text.primary,
    boxShadow: `inset -4px 4px 0px -2px ${theme.palette.divider}`,
    transform: "translateY(-50%) translateX(-50%) rotate(45deg)",
    zIndex: 0,
  },
  body: {
    color: "white",
    fontSize: 16,
  },
}));

interface Offset {
  left: number;
  top: number;
}

export interface GuidedTourReminderProps {
  offset: Offset;
  closeReminder: () => void;
}

export default function GuidedTourReminder(props: GuidedTourReminderProps) {
  const classes = useStyles();

  const getTriangle = () => {
    let posXOffset = tooltipWidth;
    let posYOffset = tooltipHeight - padY;

    let className = classes.triangleright;

    return (
      <Box
        className={classes.triangle}
        sx={{
          position: "absolute",
          left: posXOffset,
          top: posYOffset,
        }}>
        <div className={className}></div>
      </Box>
    );
  };

  const body = "Need a guided tour? Access it here.";

  const TourElement = (
    <Box
      className={classes.tooltip}
      sx={{
        position: "absolute",
        left: props.offset.left,
        top: props.offset.top,
        zIndex: 1000,
      }}>
      {getTriangle()}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}>
        <Box>
          <Typography variant="h4" className={classes.body}>
            {body}
          </Typography>
        </Box>
        <Box sx={{ marginTop: "auto" }}>
          <Link
            className={classes.link}
            onClick={() => {
              generateGtmEvent({
                event: "link",
                action: "click",
                name: "onclick",
                type: "internal link",
                region: "modal",
                section: "need a guided tour? access it here.",
                text: "got it",
              });
              props.closeReminder();
            }}
            tabIndex={0}>
            Got it
          </Link>
        </Box>
      </Box>
    </Box>
  );

  return TourElement;
}
